var map = {
  "./osmTagToNameMapping-fr.messages.ts": [
    "35208",
    [
      31987
    ]
  ],
  "./osmTagToNameMapping-it.messages.ts": [
    "90268",
    [
      56586
    ]
  ],
  "./osmTagToNameMapping-pl.messages.ts": [
    "70383",
    [
      33323
    ]
  ],
  "./osmTagToNameMapping-hu.messages.ts": [
    "29222",
    [
      14164
    ]
  ],
  "./osmTagToNameMapping-de.messages.ts": [
    "46066",
    [
      78032
    ]
  ],
  "./osmTagToNameMapping-sk.messages.ts": [
    "22665",
    [
      89049
    ]
  ],
  "./osmTagToNameMapping-en.messages.ts": [
    "9530",
    [
      63512
    ]
  ],
  "./osmTagToNameMapping-cs.messages.ts": [
    "70225",
    [
      79281
    ]
  ],
  "./osmTagToNameMapping-sl.messages.ts": [
    "43486",
    [
      62896
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 85731;
module.exports = __rspack_async_context;
